import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const DURATION_MS = 1400;
const COUNT_TO = 100;

export default function LessonCounter({ dark = false }) {
  const { t } = useTranslation();
  const [n, setN] = useState(0);
  
  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) { setN(COUNT_TO); return; }
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - start) / DURATION_MS);
      setN(Math.floor(COUNT_TO * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div data-testid="landing-lesson-counter">
      <div className={dark ? "font-display font-black text-4xl sm:text-5xl text-white tabular-nums" : "font-display font-black text-3xl sm:text-4xl text-slate-900 tracking-tighter tabular-nums"}>
        {n}+
      </div>
      <div className={`mt-1 text-[10px] uppercase tracking-widest font-semibold ${dark ? "text-slate-400" : "text-slate-500"}`}>{t("lessonCounterUi.lessons")}</div>
      <div className="mt-0.5 flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-semibold text-emerald-600 whitespace-nowrap">
        <span className="relative flex h-1.5 w-1.5 shrink-0">
          <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping" />
          <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-500" />
        </span>
        {t("lessonCounterUi.alwaysGrowing")}
      </div>
    </div>
  );
}
